(() => {
  const setupCarousel = (wrapper) => {
    if (!wrapper || wrapper.dataset.vendorCarouselReady === 'true') return;

    const track = wrapper.querySelector('[data-vendor-carousel-track]');
    const prevButton = wrapper.querySelector('[data-vendor-carousel-prev]');
    const nextButton = wrapper.querySelector('[data-vendor-carousel-next]');
    if (!track || !prevButton || !nextButton) return;

    wrapper.dataset.vendorCarouselReady = 'true';

    const scrollStep = () => {
      const firstSlide = track.querySelector('.vendor-brand-carousel__slide');
      if (!firstSlide) return 220;
      const computedTrack = window.getComputedStyle(track);
      const gap = parseFloat(computedTrack.columnGap || computedTrack.gap || 0);
      return firstSlide.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      const maxScrollLeft = track.scrollWidth - track.clientWidth - 2;
      prevButton.disabled = track.scrollLeft <= 1;
      nextButton.disabled = track.scrollLeft >= maxScrollLeft;
    };

    prevButton.addEventListener('click', () => {
      track.scrollBy({ left: -scrollStep() * 2, behavior: 'smooth' });
    });

    nextButton.addEventListener('click', () => {
      track.scrollBy({ left: scrollStep() * 2, behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(updateButtons);
      resizeObserver.observe(track);
    } else {
      window.addEventListener('resize', updateButtons);
    }

    updateButtons();
  };

  const initVendorBrandCarousel = (scope = document) => {
    const wrappers = scope.querySelectorAll('[data-vendor-carousel-wrapper]');
    wrappers.forEach(setupCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initVendorBrandCarousel());
  } else {
    initVendorBrandCarousel();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initVendorBrandCarousel(event.target);
  });
})();
